import { useCallback } from "react";
import { useIntl } from "react-intl";
import { NUMBERING_MESSAGE_PREFIX, formatIssueNumberList, } from "../utils/issueNumberList";
export var useIssueNumberListFormatter = function () {
    var formatMessage = useIntl().formatMessage;
    return useCallback(function (numbers) {
        return formatIssueNumberList(numbers, function (number) {
            return formatMessage({ id: "".concat(NUMBERING_MESSAGE_PREFIX, ".number") }, { number: number });
        });
    }, [formatMessage]);
};
